var _g, _g2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var Svg3Star = function Svg3Star(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 125",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -599,
    y: -107,
    display: "inline",
    fill: "#000000",
    stroke: "#000000",
    strokeMiterlimit: 10,
    width: 1428,
    height: 1012
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M26.789,69.895h46.895c1.308,0,2.368-1.06,2.368-2.368s-1.06-2.368-2.368-2.368H26.789c-1.308,0-2.368,1.06-2.368,2.368   S25.481,69.895,26.789,69.895z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.913,47.158c4.278,0,7.758-3.48,7.758-7.758s-3.48-7.758-7.758-7.758s-7.758,3.48-7.758,7.758   S29.635,47.158,33.913,47.158z M33.913,36.379c1.666,0,3.021,1.355,3.021,3.021c0,1.666-1.355,3.021-3.021,3.021   c-1.666,0-3.021-1.355-3.021-3.021C30.892,37.734,32.247,36.379,33.913,36.379z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.086,47.158c4.278,0,7.758-3.48,7.758-7.758s-3.48-7.758-7.758-7.758s-7.758,3.48-7.758,7.758   S61.808,47.158,66.086,47.158z M66.086,36.379c1.666,0,3.021,1.355,3.021,3.021c0,1.666-1.355,3.021-3.021,3.021   s-3.021-1.355-3.021-3.021C63.065,37.734,64.421,36.379,66.086,36.379z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50,95c24.813,0,45-20.187,45-45S74.813,5,50,5S5,25.187,5,50S25.187,95,50,95z M50,9.737   c22.201,0,40.263,18.062,40.263,40.263S72.201,90.263,50,90.263S9.737,72.201,9.737,50S27.799,9.737,50,9.737z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg3Star, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/3star.2d2e20e6.svg";
export { ForwardRef as ReactComponent };